import React, { useState } from "react";
import METAR from "./views/METAR";
import TAF from "./views/TAF";
import ATIS from "./views/ATIS";

const ContentPage1 = () => {
  const [activeTab, setActiveTab] = useState("METAR");

  return (
    <div className="h-full overflow-hidden bg-gray-300">
      <nav className="bg-gray-600 p-1 pl-2 flex justify-between items-center">
        <h1 className="text-white text-xs font-normal">MET</h1>
        <div>
          {[
            { label: "METAR", tab: "METAR" },
            { label: "TAF", tab: "TAF" },
            { label: "ATIS", tab: "ATIS" },
            { label: "RCR", tab: "RCR" }
          ].map(({ label, tab }) => (
            <button
              key={label}
              className={`p-1 text-xs mr-1 ${activeTab === tab ? "bg-gray-700" : "bg-gray-800"} text-white`}
              onClick={() => setActiveTab(tab)}
            >
              {label}
            </button>
          ))}
        </div>
      </nav>

      <div className="bg-gray-300 p-2 pt-1 pr-1 absolute right-0 top-[30px] pb-8 h-full w-full">
        {activeTab === "METAR" ? (
            <METAR />
        ) : activeTab === "TAF" ? (
            <TAF />
        ) : activeTab === "ATIS" ? (
            <ATIS />
        ) : (
            <div className="relative w-full h-full overflow-hidden">
                <iframe
                    src="https://rcr.lusep.fi/"
                    title="RCR"
                    className="border-none absolute top-0 left-0"
                    style={{
                    width: "167%",
                    height: "167%",
                    transform: "scale(0.60)",
                    transformOrigin: "top left",
                    }}
                ></iframe>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentPage1;
